/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetInactiveAccountHoldersForAccountRequest} from '@cash-web/protos/squareup/cash/janus/api/AccountHolder.pb'
import {GetInactiveAccountHoldersForAccountResponse} from '@cash-web/protos/squareup/cash/janus/api/AccountHolder.pb'


export const getInactiveAccountHoldersForAccountInternal = (request: GetInactiveAccountHoldersForAccountRequest, options?: CashRequestOptions) => post<GetInactiveAccountHoldersForAccountRequest, GetInactiveAccountHoldersForAccountResponse>("/2.0/cash/get-inactive-account-holders-for-account-internal", request, {...options, rejectOnError: true })